'use client';

import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import { PhoneApplyHub } from './PhoneApplyHub';

interface PhoneApplyModalProps {
  locale: Locale;
  jobSlug: string;
}

/**
 * @description Modal shell for the guest phone-apply flow. Mirrors
 * `PhoneFlowModal` so the layout / sizing / backdrop behavior matches
 * the existing phone-confirmation modal across the app.
 *
 * See docs/plans/phone-apply-flow.md.
 */
export const PhoneApplyModal = NiceModal.create((props: PhoneApplyModalProps) => {
  const { locale, jobSlug } = props;
  const modal = useModal();
  const { t } = useTranslation('common');

  const closeModal = () => {
    void modal.hide();
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      size="sm"
      backdropClickDisabled
      header={t('phone_apply.modal.title', 'Apply by phone')}
      body={(
        <PhoneApplyHub
          locale={locale}
          jobSlug={jobSlug}
          onSuccess={closeModal}
        />
      )}
    />
  );
});

/**
 * @description Opens the phone-apply modal. Call from the
 * PhoneApplyButton click handler in JobActions.
 */
export const showPhoneApplyModal = (props: PhoneApplyModalProps) => {
  void NiceModal.show(PhoneApplyModal, props);
};

export const closePhoneApplyModal = () => {
  void NiceModal.hide(PhoneApplyModal);
};
